import { render, staticRenderFns } from "./MusteriGuncelle.vue?vue&type=template&id=ba31dddc&scoped=true&"
import script from "./MusteriGuncelle.vue?vue&type=script&lang=js&"
export * from "./MusteriGuncelle.vue?vue&type=script&lang=js&"
import style0 from "./MusteriGuncelle.vue?vue&type=style&index=0&id=ba31dddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba31dddc",
  null
  
)

export default component.exports